<app-select [control]="control"
            [controlName]="paramDef.controlName"
            label="select.conversion_metric"
            [textGetter]="textGetter"
            [labelAnimation]="true"
            [form]="form"
            [options]="options$ | async"
            [templateOption]="option"
            [templateTrigger]="option">
  <ng-template #option let-metric>
    <app-source [item]="metric.payload" [enableTooltip]="true" *ngIf="metric"></app-source>
  </ng-template>
</app-select>
